var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-loader vh-center position-absolute z-1"},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"lds-ring vh-center position-absolute",attrs:{"title":_vm.tooltipTitle}},[_c('div'),_c('div'),_c('div'),_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }